import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__main" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = {
  key: 0,
  class: "header__breadcrumbs breadcrumbs"
}

import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';
import SvgLoader from '@/utils/SvgLoader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderArea',
  props: {
    title: {},
    breadcrumbs: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.breadcrumbs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (breadcrumb, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: breadcrumb.router
              }, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["breadcrumbs__link", { 'breadcrumbs__link--current': index === _ctx.breadcrumbs.length - 1 }]),
                  to: breadcrumb.router
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(breadcrumb.label), 1)
                  ], undefined, true),
                  _: 2
                }, 1032, ["class", "to"]),
                (index !== _ctx.breadcrumbs.length - 1)
                  ? (_openBlock(), _createBlock(SvgLoader, {
                      key: 0,
                      class: "breadcrumbs__separator",
                      name: "chevronRight"
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})